<template>
  <div class="row">
    <div class="col-lg-12">
      <h2 class="page-header">Acompanhamento</h2>

      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="list_editais_andamento"
            :show-empty="true"
            title="Editais em andamento"
            api-url="edital/listar"
            report-title="Editais"
            :fields="fields"
            :initial-page="pagina"
            :pageCollection="'acompanhamentos'"
            :appendParams="filtros"
          >
            <template slot="filters">
              <div class="col-sm-4">
                <label class="custom-font">Nº Edital</label>
                <input
                  type="text"
                  v-model="numero"
                  class="form-control"
                  name="numero_filter"
                />
              </div>
              <div class="col-sm-4">
                <label class="custom-font">Nº Processo</label>
                <input
                  type="text"
                  v-model="processo_numero"
                  class="form-control"
                  name="processo_numero_filter"
                />
              </div>
              <div class="col-sm-2">
                <label class="custom-font">Publicado</label>
                <div class="custom-select">
                  <select
                    name="publicado_filter"
                    v-model="publicado"
                    @change="consultar('list_editais_andamento')"
                    class="form-control select-selected"
                  >
                    <option value="">Todos</option>
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                </div>
              </div>
              <div class="col-xs-12">
                <button
                  @click="consultar('list_editais_andamento')" 
                  class="btn btn-default margem-topo"
                  name="btnFiltrar"
                >
                  <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                  Filtrar
                </button>
                <button
                  @click="limpar('list_editais_andamento')"
                  class="btn btn-default margem-topo"
                  name="btnLimpar"
                >
                  <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                  Limpar Filtros
                </button>
              </div>
            </template>
            <template slot="rowrender" slot-scope="props">
              <router-link
                title="Detalhes"
                class="btn btn-success"
                :to="{
                  name: 'acompanhamento_detalhes',
                  params: { edital_id: props.rowData.id }
                }"
              >
                <font-awesome-icon :icon="'search'" />
              </router-link>
            </template>
          </list>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="list_editais_encerrados"
            :show-empty="true"
            title="Editais encerrados"
            api-url="edital/listar"
            report-title="Editais"
            :fields="fields"
            :initial-page="pagina"
            :pageCollection="'acompanhamentos'"
            :appendParams="filtros"
          >
            <template slot="filters">
              <div class="col-sm-4">
                <label class="custom-font">Nº Edital</label>
                <input
                  type="text"
                  v-model="numero"
                  class="form-control"
                  name="numero_filter"
                />
              </div>
              <div class="col-sm-4">
                <label class="custom-font">Nº Processo</label>
                <input
                  type="text"
                  v-model="processo_numero"
                  class="form-control"
                  name="processo_numero_filter"
                />
              </div>
              <div class="col-sm-2">
                <label>Publicado</label>
                <div class="custom-select">
                  <select
                  name="publicado_filter"
                  v-model="publicado"
                  @change="consultar"
                  class="form-control select-selected"
                >
                  <option value="">Todos</option>
                  <option value="0">Não</option>
                  <option value="1">Sim</option>
                </select>
                </div>
              </div>
              <div class="col-xs-12">
                <button
                  @click="consultar('list_editais_encerrados')"
                  class="btn btn-default margem-topo"
                  name="btnFiltrar"
                >
                  <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtrar
                </button>
                <button
                  @click="limpar('list_editais_encerrados')"
                  class="btn btn-default margem-topo"
                  name="btnLimpar"
                >
                  <font-awesome-icon :icon="'eraser'"></font-awesome-icon> Limpar Filtros
                </button>
              </div>
            </template>
            <template slot="rowrender" slot-scope="props">
              <router-link
                title="Detalhes"
                class="btn btn-success"
                :to="{
                  name: 'acompanhamento_detalhes',
                  params: { edital_id: props.rowData.id }
                }"
              >
                <font-awesome-icon :icon="'search'" />
              </router-link>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}
</style>

<script>
import list from '@/components/common/DataTable'
import { request } from '@/request'

export default {
  name: 'editais',
  data() {
    return {
      fields: [
        {
          name: 'numero',
          title: 'Nº Edital',
          sortField: 'numero',
          filterable: true
        },
        {
          name: 'processo_numero',
          title: 'Nº Processo',
          sortField: 'processo_numero',
          width: '15%',
          filterable: true
        },
        {
          name: 'publicado',
          title: 'Publicado',
          sortField: 'publicado',
          filterable: true,
          callback(value) {
            return value ? 'Sim' : 'Não'
          },
          titleClass: 'text-center',
          dataClass: 'text-center'
        },
        {
          name: 'cargos_descricao',
          title: 'Cargos',
          callback(value) {
            let cargos = value[0]
            for (let index = 1; index < value.length; index++) {
              cargos += `, ${value[index]}`
            }
            return cargos
          }
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center',
          dataClass: 'text-center col-xs-1'
        }
      ]
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  methods: {
    editar(data) {
      this.$router.push({
        name: 'salvar_edital',
        params: data
      })
    },
    consultar(keyTable) {
      const me = this
      this.$nextTick(function () {
        me.$refs[keyTable].refresh()
      })
    },
    limpar() {
      /**
       * Se não fizer desse jeito, um a um, não vai.
       * Passando um objeto completo, dá pau. Precisa limpar 2 vezes.
       * Full bugado.
       */
      this.numero = ''
      this.processo_numero = ''
      this.publicado = ''
      this.$refs.vuetable.refresh()
    },
    teste() {
      const [table] = document.getElementsByTagName('table')
      const html = table.innerHTML

      request.post('teste2', { html }).then(response => {
        var blob = new Blob([response.data])
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'print.pdf'
        link.click()
      })
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'acompanhamentos',
        value: 1
      })
    }
  },
  computed: {
    filtros() {
      const { numero, processo_numero, publicado, status } = this
      return {
        numero,
        processo_numero,
        publicado,
        status
      }
    },
    pagina: {
      get() {
        const { acompanhamentos } = this.$store.state.vuetableState
        const { pagina } = acompanhamentos
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'acompanhamentos',
          value: value
        })
      }
    },
    numero: {
      get() {
        const { acompanhamentos } = this.$store.state.vuetableState
        const { numero } = acompanhamentos.filtros

        return numero
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'numero',
          collection: 'acompanhamentos',
          value: value
        })
        this.resetPageStore()
      }
    },
    processo_numero: {
      get() {
        const { acompanhamentos } = this.$store.state.vuetableState
        const { processo_numero } = acompanhamentos.filtros

        return processo_numero
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'processo_numero',
          collection: 'acompanhamentos',
          value: value
        })
        this.resetPageStore()
      }
    },
    publicado: {
      get() {
        const { acompanhamentos } = this.$store.state.vuetableState
        const { publicado } = acompanhamentos.filtros

        return publicado
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'publicado',
          collection: 'acompanhamentos',
          value: value
        })
        this.resetPageStore()
      }
    },
    status: {
      get() {
        const { acompanhamentos } = this.$store.state.vuetableState
        const { status } = acompanhamentos.filtros

        return status
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'status',
          collection: 'acompanhamentos',
          value: value
        })
        this.resetPageStore()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/concursos/acompanhamento/index.vue